var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparklesYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4362_17421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    y: 0.577148,
    width: 32.3077,
    height: 32.3077,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4362_17421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4431 12.1548L24.0297 8.99136L20.8662 7.5779L24.0297 6.13078L25.4431 3.00098L26.8566 6.13078L30.0201 7.5779L26.8566 8.99136L25.4431 12.1548ZM25.4431 30.4625L24.0297 27.3327L20.8662 25.8856L24.0297 24.4721L25.4431 21.3087L26.8566 24.4721L30.0201 25.8856L26.8566 27.3327L25.4431 30.4625ZM12.4864 25.8856L9.65948 19.5923L3.36621 16.7317L9.65948 13.8712L12.4864 7.5779L15.347 13.8712L21.6402 16.7317L15.347 19.5923L12.4864 25.8856Z",
    fill: "#FFCE00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesYellow);
export default __webpack_public_path__ + "static/media/sparkles-yellow.f79484b48ee5f1698780844012cf1588.svg";
export { ForwardRef as ReactComponent };